import React from "react"

export const FormBody = ({className, children}) => {
    return <div className={`form-body ${className ? className : ''}`}>
        {children}
    </div>
}

export const FormBodyFlexRow = (props) => {
    return <FormBody {...props} className="flex-row-border-content"></FormBody>
}

export const FormBodyFlexColumn = (props) => {
    return <FormBody {...props} className="flex-column-border-content"></FormBody>
}

